// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Settings_wrapper__3qSaf","sliderWrapper":"Settings_sliderWrapper__3S-UH","slider":"Settings_slider__3rsB9"};